import UrlControl from '@bingads-webui-component-legacy/form/view/control/url';

export default {
  control: UrlControl,
};
